<script lang="ts">
	import {getModal} from "../../(popups)/OrderStornoPopup.svelte";
	
	export let name: string;
	export let value: string;
	export let unit: string = '';
	export let isSearch: boolean = false;
	export let scooterName: string;

	function openModal(name: string) {
		getModal(name, scooterName).open();
	}
</script>

{#if value}
	<tr class="border-graybg border-b">
		<th scope="row" class="text-left w-full p-3 font-bold md:w-1/2">{name.replace("Vin rám (pozice)", "Kde najdu VIN?")
				.replace("Vin štítek (pozice)", "Kde najdu výrobní štítek?")}</th>
		{#if value.toUpperCase() === 'NEVIM'}
			<td class="w-full p-3 text-right md:w-1/2">
				Neuvedeno
				<div class="inline-block font-bold text-red cursor-pointer" on:click={() => openModal(name)}>
					(doplnit)
				</div>
			</td>
		{:else}
			{#if isSearch}
				<td class="w-full p-3 text-right md:w-1/2">
					<a class="inline-block font-bold text-red" href="/vyhledavani/{value}" data-sveltekit-preload-data="tap">
						{value} {unit}
					</a>
				</td>
			{:else}
				<td class="w-full p-3 text-right md:w-1/2">{value} {unit}</td>
			{/if}
		{/if}
	</tr>
{/if}
